import type { MarketDataProvider } from './MarketDataProvider';
import { YahooFinanceProvider } from './providers/YahooFinanceProvider';

const providers = new Map<string, MarketDataProvider>();

export function registerProvider(provider: MarketDataProvider): void {
  providers.set(provider.id, provider);
}

export function getProvider(id: string): MarketDataProvider {
  const provider = providers.get(id);
  if (!provider) throw new Error(`Unknown market data provider: ${id}`);
  return provider;
}

registerProvider(new YahooFinanceProvider());
